import Vue from 'vue';
import Router, { Route } from 'vue-router';
import AnonymousRoot from './views/AnonymousRoot.vue';
import Root from './views/Root.vue';
import Overview from './views/overview/Overview.vue';
import GeneralError from './views/errors/GeneralError.vue';

import store from './store/store';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            // base route for authenticated pages
            path: '/',
            name: 'root',
            component: Root,
            beforeEnter: async (to: Route, from: Route, next: Function) => {
                await store.dispatch('fetchRoot');
                await store.dispatch('user/fetchUser');
                next();
            },
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: '/overview',
                    name: 'overview',
                    component: Overview,
                    beforeEnter: async (to: Route, from: Route, next: Function) => {
                        const tribesPromise = store.dispatch('data/fetchTribes');
                        const hivesPromise = store.dispatch('data/fetchHives');
                        const accountsPromise = store.dispatch('data/fetchAccounts');
                        const accountClustersPromise = store.dispatch('data/fetchAccountClusters');
                        const employeesPromise = store.dispatch('data/fetchEmployees');
                        const skillsPromise = store.dispatch('data/fetchSkills');
                        const capabilitiesPromise = store.dispatch('data/fetchCapabilities');
                        await Promise.all([tribesPromise, hivesPromise, accountsPromise,accountClustersPromise, employeesPromise, skillsPromise, capabilitiesPromise]);
                        next();
                    },
                }
            ]
        },
        // anonymous accessible pages
        {
            path: '/anon',
            name: 'anonymousRoot',
            component: AnonymousRoot,
            children: [
                {
                    path: '/error',
                    name: 'error',
                    component: GeneralError
                },
                {
                    path: '/error/notallowed',
                    name: 'notallowed',
                    component: GeneralError
                },
                {
                    path: '/error/notfound',
                    name: 'notfound',
                    component: GeneralError
                }
            ]
        }
    ],
    scrollBehavior(to: Route, from: Route, savedPosition: void | { x: number; y: number }) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

export default router;
